import gql from 'graphql-tag';

const MODIFY_COLLECTED_VALUES = gql`
	mutation modifyCollectedValues(
		$serviceDocketId: ID!,
		$values: CollectedValues,
	) {
		modifyCollectedValues(
			serviceDocketId: $serviceDocketId
			values: $values
		) {
			id
			notesCollected
			coinsCollected
			collectedVariance

			serviceRun {
				id
				cashReconciliationStatus
				coinsCollected
				notesCollected
				collectedVariance
			}
		}
	}
`;

export default MODIFY_COLLECTED_VALUES;

